export enum ReviewItemType {
  Article = 'article',
  Guidance = 'guidance',
  Incident = 'incident',
  Registration = 'registration',
  FieldSafetyNotice = 'fieldSafetyNotice',
  Standard = 'standard',
  default = '',
}
